// eslint ignore
import Vue from 'vue'

// taken from https://github.com/wrabit/vue-textarea-autogrow-directive/blob/master/src/VueTextareaAutogrowDirective.js
// see https://github.com/wrabit/vue-textarea-autogrow-directive/issues/3
// this appears to be the best vue lib for this

const TextareaAutogrowDirective = {
  name: 'autogrow',
  inserted(el) {
    let observe

    // If used in a component library such as buefy, a wrapper will be used on the component so check if a child is the textarea
    el =
      el.tagName.toLowerCase() === 'textarea'
        ? el
        : el.querySelector('textarea')

    const minHeight = parseFloat(
      getComputedStyle(el).getPropertyValue('min-height')
    )

    if (window.attachEvent) {
      observe = function(element, event, handler) {
        element.attachEvent('on' + event, handler)
      }
    } else {
      observe = function(element, event, handler) {
        element.addEventListener(event, handler, false)
      }
    }

    const resize = () => {
      el.style.height = 'auto'
      const border = el.style.borderTopWidth * 2
      el.style.height =
        (el.scrollHeight < minHeight ? minHeight : el.scrollHeight) +
        border +
        'px'
    }

    // 0-timeout to get the already changed el
    const delayedResize = () => {
      window.setTimeout(resize, 0)
    }

    // When the textarea is being shown / hidden
    const respondToVisibility = (element, callback) => {
      const intersectionObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.intersectionRatio > 0) callback()
          })
        },
        {
          root: document.documentElement
        }
      )

      intersectionObserver.observe(element)
    }

    respondToVisibility(el, resize)
    observe(el, 'change', resize)
    observe(el, 'cut', delayedResize)
    observe(el, 'paste', delayedResize)
    observe(el, 'drop', delayedResize)
    observe(el, 'input', resize)

    resize()
  }
}

// eslint-disable-next-line no-unused-vars
const VueTextareaAutogrowDirective = {
  install(Vue) {
    Vue.directive(TextareaAutogrowDirective.name, TextareaAutogrowDirective)
  }
}

Vue.use(VueTextareaAutogrowDirective)
